module.exports = "https://r.nearpod.com/assets/media/image/help-4c69c5a1dca7a25d2f39ecf2acaad9d4.svg";